import React, { useState } from "react";
import { Container, Row, Col, Card, Table, Modal, Button } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import Image from "./basico/image";
import GatsbyImage from "gatsby-image";

import Cotizador from "./cotizador";

import carPlaceholder from "../../images/car-placeholder.png";

//SHIMMER CARD CARGANDO NUEVOS Y SEMINUEVOS
export function ShimmerCarCardCargando({auto}){
    let arrayShimmers = auto === "Seminuevos" ? [1, 2, 3, 4, 5, 6, 7, 8] : [1, 2, 3, 4];
    return(
        <Row xl={auto === "Seminuevos" ? 4 : 3} lg={auto === "Seminuevos" ? 4 : 3} md={auto === "Seminuevos" ? 3 : 2} sm={1} xs={1} className="blink px-2">
            {arrayShimmers?.map((n, index) => (
                <Col key={index} className="mb-3 px-2">
                    <Card className="car-card shadow-sm text-primary-colorh-100">
                        <Card.Header>
                            <img alt="carPlaceholder" src={carPlaceholder} style={{width: '100%', height: '100%'}}/>
                        </Card.Header>
                        <Card.Body style={{height: 75}}>

                        </Card.Body>
                        <Card.Footer className="bg-white">
                            <Row style={{height: 15}}>
                                
                            </Row>
                        </Card.Footer>
                    </Card>
                </Col>
            ))}
        </Row>
    )
}

export function ShimmerCarCarrousel(){
    let arrayShimmers = [1, 2, 3];
    return(
        <>
            {arrayShimmers.map((obj, index) => (
                <div key={index} className="blink px-2">
                    <Card className="car-card shadow-sm text-primary-colorh-100">
                        <Card.Header>
                            <img alt="carPlaceholder" src={carPlaceholder} style={{width: '100%', height: '50%'}}/>
                        </Card.Header>
                        <Card.Body>
                            <Card.Title>
                                <h6 className="texto-carCardCarrousel-titulo">
                                    
                                </h6>
                            </Card.Title>
                        </Card.Body>
                    </Card>
                </div>
            ))}
        </>
    )
}

export function ShimmerCarImagenLujos({}){
    return(
        <div className="blink" 
        style={{
            margin: 2,
            width: '100%',
            height: '50%',
            backgroundColor: `rgba(0, 0, 0, 0.15)`,
            marginLeft:  0,
            marginRight:  0,
        }}>
            <Image
                fileName="car-placeholder.png"
            />
        </div>
    )
}

export function ShimmerCarTextosLujo({width, height, color}){
    return(
        <div xs={12} md={6} xl={3} className="blink pb-2"
        style={{
            margin: 2,
            width: width,
            height: height,
            backgroundColor: color,
            marginLeft:  0,
            marginRight:  0,
        }}
        ></div>
    )
}

export function ShimmerBlogCargando(){
    return(
        <>
            {[1, 2, 3, 4, 5, 6].map((n, index) => (
                <Row key={index}>
                    <Col xs={12} key={index} className="border-bottom py-3">
                        <Row>
                            <Col xl={4}> 
                                <div className="blink"
                                    style={{ width: '100%', height: 110, backgroundColor: `rgba(0, 0, 0, 0.15)` }} >
                                </div>
                            </Col>
                            <Col xl={8} className="pt-xs-2">
                                <span className="blink">
                                    ▮▮▮▮ ▮▮ ▮▮▮▮ ▮▮
                                </span>
                                <div className="blink"
                                    style={{ width: '100%', height: 10, backgroundColor: `rgba(0, 0, 0, 0.15)`}} >
                                </div>
                                <div className="blink mt-2"
                                    style={{ width: '100%', height: 10, backgroundColor: `rgba(0, 0, 0, 0.15)` }} >
                                </div>
                                <div className="blink mt-2"
                                    style={{ width: '100%', height: 10, backgroundColor: `rgba(0, 0, 0, 0.15)` }} >
                                </div>
                                <div className="blink mt-2"
                                    style={{ width: '100%', height: 10, backgroundColor: `rgba(0, 0, 0, 0.15)` }} >
                                </div>
                            
                                <Row className="justify-content-end pt-3 pr-3 pl-auto right">
                                    <div className="blink"
                                        style={{
                                            width: '20%',
                                            height: 30,
                                            backgroundColor: `rgba(0, 0, 0, 0.15)`,
                                        }}
                                        >
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ))}
        </>
    )
}

//TABLA DE DETALLES PARA CARRO SE USA EN MODAL3PASOS
export function TablaDetallesCotizador({ landing, infoCar, infoCotiza, cargando, seguroSeleccionado, setShowSeguros, pagoMensual, setShowCotizador }){

    return(
        <>
            <Table width="100%">
                <tbody className={landing  ? "textcolor-Tabla-LandingLujo" : "text-white"}>
                    <tr>
                        <td style={{ width: "90px"}}>
                            <strong>Modelo</strong>
                        </td>
                        <td style={{ textTransform: "uppercase" }}>
                        {infoCar?.model} {infoCar?.year} - {infoCotiza?.version}
                        </td>
                    </tr>

                    <tr>
                        <td>
                        <strong>Precio</strong>
                        </td>
                        <td>
                        <strong style={{ fontSize: "18px" }} className="modal-textoDetalle-3pasos">
                            $<NumericFormat displayType="text" value={infoCotiza?.precio} allowLeadingZeros thousandSeparator="," decimalScale={2} /> MXN
                        </strong>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ width: "90px" }}>
                        <strong>Plazo</strong>
                        </td>
                        <td>
                            <strong className="modal-textoDetalle-3pasos">
                                {cargando === true ? (
                                    <div xs={12} md={6} xl={3} className="blink"
                                        style={{
                                            margin: 2,
                                            width: '100%',
                                            height: 20,
                                            backgroundColor: `rgba(0, 0, 0, 0.15)`,
                                            marginLeft:  0,
                                            marginRight:  0,
                                        }}
                                        >
                                        <h3 style={{ overflow: "hidden", height: 50, fontSize: 14, color: "#a2a2a2"}}>
                                            {/*{promo.description.substring(0, 29)}...*/}
                                        </h3>
                                    </div>
                                ) 
                                :  
                                <>{infoCotiza?.plazo} meses</>
                                }
                            </strong>
                        </td>
                    </tr>

                    <tr>
                        <td>
                        <strong>Enganche</strong>
                        </td>
                        <td>
                            <strong className="modal-textoDetalle-3pasos">
                                {cargando === true ? (
                                        <div xs={12} md={6} xl={3} className="blink"
                                            style={{
                                                margin: 2,
                                                width: '100%',
                                                height: 20,
                                                backgroundColor: `rgba(0, 0, 0, 0.15)`,
                                                marginLeft:  0,
                                                marginRight:  0,
                                            }}
                                            >
                                            <h3 style={{ overflow: "hidden", height: 50, fontSize: 14, color: "#a2a2a2"}}>
                                                {/*{promo.description.substring(0, 29)}...*/}
                                            </h3>
                                        </div>
                                    ) 
                                    :  
                                    <> $<NumericFormat displayType="text" value={infoCotiza?.enganche} allowLeadingZeros thousandSeparator="," decimalScale={2}/> MXN</>
                                }
                            </strong>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ verticalAlign: "middle"}}>
                            <strong>Seguros</strong>
                        </td>
                        <td >
                        <button className="btn btn-default p-0 d-flex w-100 align-items-start justify-start" onClick={() => setShowSeguros(true)} >
                            <div className="flex-grow-1 text-left" style={{color: 'white', textAlign: 'left'}}>
                                {seguroSeleccionado ? 
                                    <>
                                        {seguroSeleccionado[0]?.insuranceCompany}/{seguroSeleccionado[0]?.period} meses de 
                                        $<NumericFormat className="px-1" displayType="text" value={seguroSeleccionado[0]?.monthlyPrice} allowLeadingZeros thousandSeparator="," />MXN 
                                        (contado: $<NumericFormat className="px-1" displayType="text" value={seguroSeleccionado[0]?.price} allowLeadingZeros thousandSeparator="," />MXN)
                                    </>
                                    : null}
                            </div>
                            <div className="flex-grow-0" style={{ width: 24, height: 24 }}>
                                <Image
                                    fileName="iconos_pluma-azul.png"
                                    alt="editar carro"
                                    width={24}
                                />
                            </div>
                        </button>
                        </td>
                    </tr>
                </tbody>
            </Table>
            <Row>
                <Col>
                    {cargando === true ? (
                        <div xs={12} md={6} xl={3} className="blink pb-2"
                            style={{
                                margin: 2,
                                width: '100%',
                                height: 20,
                                backgroundColor: `rgba(0, 0, 0, 0.15)`,
                                marginLeft:  0,
                                marginRight:  0,
                            }}
                            >
                            <h3 style={{ overflow: "hidden", height: 50, fontSize: 14, color: "#a2a2a2"}}>
                                {/*{promo.description.substring(0, 29)}...*/}
                            </h3>
                        </div>
                    ) : (
                        <center>
                            <p>Financiamiento a {infoCotiza?.plazo} meses con enganche de $<NumericFormat displayType="text" value={infoCotiza?.enganche} allowLeadingZeros thousandSeparator="," decimalScale={2}/> MXN</p>
                            <Col lg={6} sm={12}>
                                pago mensual de:
                            </Col>
                            <Col lg={6} sm={12}>
                                <h3 className="modal-precioMensual-3pasos">
                                    
                                        <>$<NumericFormat className="px-1" displayType="text" value={infoCotiza?.mensualidad} allowLeadingZeros thousandSeparator="," />MXN</>
                    
                                </h3>
                            </Col>
                        </center>
                    ) }
                </Col>
            </Row>

            <Row>
                <Col lg={10} sm={10}>
                    <i className="text-right text-wrap" style={{ fontSize: "10px" }}>
                        *Planes sujetos a cambios sin previo aviso, crédito sujeto a
                        aprobación por financiera.
                        <br />
                        No incluye (Placas | Seguros), Planes SIN anualidades. Aplican
                        restricciones.
                    </i>
                </Col>

                <Col lg={2} sm={2}>
                    <div className="btn-editar-3pasos" role="button" onClick={() => setShowCotizador(true)}>
                        <Image
                            fileName="iconos_pluma-azul.png"
                            alt="editar carro"
                            width="100%"
                        />
                    </div>
                </Col>
            </Row>
        </>
    )
}

//MODAL COTIZA Y MODAL SEGUROS, SE UTLIZA EN MODAL3PASOS
export function ModalSeguros({seguros, show, onHide, selected = 0, setSeguroSeleccionado}){
    
    const [ selectedId, setSelectedId ] = useState(selected);

    function onCloseModal(){
        let filterSeguro = seguros.filter((obj, i) => i === selectedId);
        setSeguroSeleccionado(filterSeguro);
        onHide();
    }

    return(
        <Modal centered show={show} onHide={onHide}>
            <Modal.Header>
                <h5>Seguro</h5>
            </Modal.Header>
            <Modal.Body>
                {seguros?.map((obj, i) => {
                    return(
                        <Button key={i} 
                            className={"d-flex p-3 btn w-100 d-flex" + (selectedId === i ? "bg-white" : " border-bottom modal-botonSeguros-3pasos")} 
                            onClick={() => {setSelectedId(i);}} 
                        >
                            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                                <div style={{fontSize: 14}}>
                                {obj.insuranceCompany}/{obj.period} meses de $<NumericFormat className="px-1" displayType="text" value={obj.monthlyPrice} allowLeadingZeros thousandSeparator="," />MXN (contado: $<NumericFormat className="px-1" displayType="text" value={obj.price} allowLeadingZeros thousandSeparator="," />MXN)
                                </div>
                                <div style={{width: 25}}>
                                    <Image
                                        fileName="check.png"
                                        alt="check seguro"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </Button>
                    )
                })}
            </Modal.Body>
            <Modal.Footer style={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button onClick={() => onCloseModal()}>Aplicar</Button>
            </Modal.Footer>
        </Modal>
    )

}

export function ModalCotiza({show, onHide, infoCotiza, calcularCotiza, setCargando}){
    return(
        <Modal centered show={show} onHide={onHide}>
            <Modal.Header>
                Cambiar plazo
            </Modal.Header>
            <Modal.Body>
                <Cotizador setCargando={setCargando} versionCar1={infoCotiza?.version} precioCar1={infoCotiza?.precio} idCar1={infoCotiza?.id} calcularModal={false} calcularCotiza={calcularCotiza} onHide={onHide}/>
            </Modal.Body>
        </Modal>
    )

}

//  COLORES CARRO DE LUJO   
export function SeccionColoresLujo({car, onCambioColor, selectColor, noModal, setShowColors}){
    return(
        <>
            <Row>
                <Row className="pt-2 pb-2">
                    <Col lg={noModal === true ? 4 : 2} className="ContainerColoresItems-landingLujo">
                        <div className="TituloColor-landingLujo">Colores: </div>
                    </Col>
                    <Col lg={noModal === true ? 8 : 10} className="ContainerColoresItems-landingLujo pt-2">
                        {car && car.colors.length > 0 ? (
                            car.colors.map((obj, i) => {
                                return(
                                    <Button 
                                        key={i} 
                                        className={selectColor.nombre === obj.name ? "cuadroItemColos-landingLujos-active" : "cuadroItemColos-landingLujos"}
                                        style={{ backgroundColor: obj.hexadecimal, borderColor: '#c0c0c0', outline: 'none'}}
                                        onClick={() => onCambioColor(obj)}
                                        id={"color-" + i}
                                    />
                                )
                            })
                        ) : (<div>No hay colores</div>)}
                    </Col>
                </Row>
                <Row className="pb-4">
                    <div className="imagenCarros-landingLujos" style={noModal === true ? {cursor: 'default', height: 440} : {cursor: 'pointer', height: 210}} onClick={() => noModal === true ? false : setShowColors(true)}>
                        <GatsbyImage
                            fluid={{
                                aspectRatio: 1 / 1,
                                src: `${selectColor.image}`,
                                srcSet: `${selectColor.image}, ${selectColor.image}`,
                                sizes: "quality: 80",
                            }}
                            style={{height: '100%'}}
                            imgStyle={{objectFit: 'contain'}}
                        />
                    </div>
                    <div className="NombreColor-landingLujo">
                        <center>{selectColor.nombre}</center>
                    </div>
                </Row>
            </Row>
        </>
    )
}

//Separador se usa en tres paginas
export function Separador() {
    return (
        <center className="p2 mt-4" >
            <div className="hr-separador-1 pb-3"></div>
            <div className="hr-separador-2"></div>
        </center>
    )
}